import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"), 
      children: [
        // Property Intel URLs
        {
          name: "Sign Up",
          path: "pages/signup",
          component: () => import("@/views/dashboard/pages/Signup"),
          meta: {
            requiresGuest: true
          }
        },
        {
          name: "Login",
          path: "pages/login",
          component: () => import("@/views/dashboard/pages/Login"),
          meta: {
            requiresGuest: true
          }
        },
        {
          name: "Forgot",
          path: "pages/forgot",
          component: () => import("@/views/dashboard/pages/Forgot"),
          meta: {
            requiresGuest: true
          }
        },
        {
          name: "Address Search Bar",
          path: "pages/search-bar",
          component: () => import("@/views/dashboard/pages/SearchBar"),
          alias: "pages/search-bar"
        },        
        {
          name: "Property Search",
          path: "/",
          component: () => import("@/views/dashboard/pages/Search"),
          alias: "pages/search"
        },
        {
          name: "Dashboard",
          path: "pages/user-dashboard",
          component: () => import("@/views/dashboard/UserDashboard"),
          meta: {
            requiresAuth: true
          }
        },
        {
          name: "My Account",
          path: "pages/user",
          component: () => import("@/views/dashboard/pages/UserProfile"),
          meta: {
            requiresAuth: true
          }
        },
        {
          name: "Subscribe",
          path: "pages/subscribe",
          component: () => import("@/views/dashboard/pages/Subscription"),
        },
        {
          name: "Resources",
          path: "pages/resources",
          component: () => import("@/views/dashboard/pages/Resources"),
          meta: {
            requiresAuth: true
          }
        },
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  // if still in soft launch mode hide all pages
  if (to.matched.some(record => record.meta.requiresAuth) 
    && process.env.VUE_APP_SOFTLAUNCH_MODE === "true") {
    next({
      path: "/",
      query: {
        redirect: to.fullPath
      }
    });
    return;
  }

  // Get current user from Firebase (source of truth for auth state)
  const currentUser = firebase.auth().currentUser;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Route requires authentication
    if (!currentUser) {
      // Not logged in, redirect to home
      if (to.path === "/") {
        next();
      } else {
        next({
          path: "/",
          query: {
            redirect: to.fullPath
          }
        });
      }
    } else {
      // Logged in, allow access
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Route requires guest (not logged in)
    if (currentUser) {
      // Already logged in, redirect to home
      if (to.path === "/") {
        next();
      } else {
        next({
          path: "/",
          query: {
            redirect: to.fullPath
          }
        });
      }
    } else {
      // Not logged in, allow access
      next();
    }
  } else {
    // No auth requirements, allow access
    next();
  }
});

export default router;
